import React, { Suspense } from 'react'
import { Route, Routes } from 'react-router-dom'
import Preloader from '../components/Preloader/Preloader'

const HomePage = React.lazy(() => import(/* webpackChunkName: "home" */ '../components/HomePage/HomePage'))
const Cart = React.lazy(() => import(/* webpackChunkName: "cart" */ '../components/Cart/Cart'))
const SingleProduct = React.lazy(() => import(/* webpackChunkName: "product" */ '../components/Products/SingleProduct'))
const SingleCategory = React.lazy(() => import(/* webpackChunkName: "catalog" */ '../components/Categories/SingleCategory'))
const Checkout = React.lazy(() => import(/* webpackChunkName: "checkout" */ '../components/Checkout/Checkout'))
const AdminPanel = React.lazy(() => import(/* webpackChunkName: "admin" */ '../components/AdminPanel/AdminPanel'))
const SearchResults = React.lazy(() => import(/* webpackChunkName: "search" */ '../components/Search/SearchResults'))
const Favorites = React.lazy(() => import(/* webpackChunkName: "favorites" */ '../components/Favorites/Favorites'))
const UserOrders = React.lazy(() => import(/* webpackChunkName: "orders" */ '../components/UserOrders/UserOrders'))
const Profile = React.lazy(() => import(/* webpackChunkName: "profile" */ '../components/Profile/Profile'))
const DeliveryPage = React.lazy(() => import(/* webpackChunkName: "info" */ '../components/InfoPage/DeliveryPage'))
const PaymentPage = React.lazy(() => import(/* webpackChunkName: "info" */ '../components/InfoPage/PaymentPage'))
const NotFound = React.lazy(() => import(/* webpackChunkName: "not-found" */ '../components/NotFound/NotFound'))

const RouteFallback = () => <Preloader message="Завантаження…" />

const AppRoutes = () => (
  <Suspense fallback={<RouteFallback />}>
    <Routes>
      <Route index path='/' element={<HomePage />} />
      <Route path='/profile' element={<Profile />} />
      <Route path='/favorites' element={<Favorites />} />
      <Route path='/orders' element={<UserOrders />} />
      <Route path='/products/:slugOrId' element={<SingleProduct />} />
      <Route path='/categories/:slugOrId' element={<SingleCategory />} />
      <Route path='/cart' element={<Cart />} />
      <Route path='/checkout' element={<Checkout />} />
      <Route path='/search' element={<SearchResults />} />
      <Route path='/delivery' element={<DeliveryPage />} />
      <Route path='/payment' element={<PaymentPage />} />
      <Route path='/admin' element={<AdminPanel />} />
      <Route path='*' element={<NotFound />} />
    </Routes>
  </Suspense>
)

export default AppRoutes;
